import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { captureSessionTokenFromUrl } from "./lib/api";
import "./index.css";

// Pick up the session token the OAuth callback left in the URL fragment (used
// as a Bearer fallback when third-party cookies are blocked).
captureSessionTokenFromUrl();

// Страницы грузятся лениво: после деплоя старые чанки исчезают с диска и
// dynamic import падает у открытых вкладок. Единственное лечение — reload,
// vite даёт для этого событие.
window.addEventListener("vite:preloadError", () => {
  window.location.reload();
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter basename={import.meta.env.BASE_URL.replace(/\/$/, "")}>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
